import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './footer.css';

function Footer() {
  const location = useLocation();
  const hideFooterRoutes = ["/login2"];
  const [version, setVersion] = useState('');

  useEffect(() => {
    fetch('/api/version')
      .then(res => res.json())
      .then(data => setVersion(data.version))
      .catch(err => console.error('Failed to fetch version:', err));
  }, []);

  if (hideFooterRoutes.includes(location.pathname)) {
    return null;
  }

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="site-footer__top">
          <section className="footer-contact">
            <p>U.S. DEPARTMENT OF TRANSPORTATION</p>
            <p><strong>Federal Motor Carrier Safety Administration</strong></p>
            <p>1200 NEW JERSEY AVENUE, SE</p>
            <p>WASHINGTON, DC 20590</p>
            <p>1-800-832-5660</p>
          </section>
          <section className='footer-contact'>
            {/* You had an incomplete section here, removed or complete if needed */}
          </section>

          <section className="footer-social">
            <a className="subscribe-button" href="https://public.govdelivery.com/accounts/USDOTFMCSA/subscriber/new">
              Subscribe to email updates
            </a>
            <ul className="social-icons">
              <li><a href="https://www.facebook.com/FMCSA/" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a></li>
              <li><a href="https://twitter.com/FMCSA" aria-label="Twitter"><i className="fab fa-twitter"></i></a></li>
              <li><a href="https://www.instagram.com/dot_fmcsa/" aria-label="Instagram"><i className="fab fa-instagram"></i></a></li>
              <li><a href="https://www.youtube.com/user/usdotgov" aria-label="YouTube"><i className="fab fa-youtube"></i></a></li>
            </ul>
          </section>
        </div>
      </div>

      <div className="container">
        <div className="site-footer__bottom">
          <section className="footer-column">
            <h2>About</h2>
            <ul>
              <li><a href="https://www.fmcsa.dot.gov/mission/about-us">About FMCSA</a></li>
              <li><a href="https://www.fmcsa.dot.gov/regulations">Regulations</a></li>
              <li><a href="https://www.fmcsa.dot.gov/safety">Safety</a></li>
              <li><a href="https://www.fmcsa.dot.gov/safety/analysis-research-technology">Analysis</a></li>
              <li><a href="https://portal.fmcsa.dot.gov/login">FMCSA Portal</a></li>
            </ul>
          </section>
          <section className="footer-column">
            <h2>News and Events</h2>
            <ul>
              <li><a href="https://www.fmcsa.dot.gov/newsroom">FMCSA Newsroom</a></li>
              <li><a href="https://www.fmcsa.dot.gov/newsroom/press-releases">Press Releases</a></li>
              <li><a href="https://www.fmcsa.dot.gov/emergency-declarations">Emergency Declarations</a></li>
            </ul>
          </section>
          <section className="footer-column">
            <h2>Resources</h2>
            <ul>
              <li><a href="https://www.fmcsa.dot.gov/career-center">Career Center</a></li>
              <li><a href="https://www.fmcsa.dot.gov/resources-for-carrier-companies">Resources for Carriers</a></li>
              <li><a href="https://www.fmcsa.dot.gov/resources-for-consumers">Resources for Consumers</a></li>
              <li><a href="https://www.fmcsa.dot.gov/resources-for-drivers">Resources for Drivers</a></li>
              <li><a href="https://www.fmcsa.dot.gov/registration/forms">Forms</a></li>
              <li><a href="https://www.fmcsa.dot.gov/contact-us">Contact Us</a></li>
              <li><a href="https://www.fmcsa.dot.gov/trendingtopics">Trending Topics</a></li>
            </ul>
          </section>
          <section className="footer-column">
            <h2>Policies, Rights, Legal</h2>
            <ul>
              <li><a href="https://www.transportation.gov/about">About DOT</a></li>
              <li><a href="https://www.transportation.gov/budget/dot-budget-and-performance">Budget and Performance</a></li>
              <li><a href="https://www.civilrights.dot.gov/">Civil Rights</a></li>
              <li><a href="https://www.fmcsa.dot.gov/foia">FOIA</a></li>
              <li><a href="https://www.transportation.gov/dot-information-dissemination-quality-guidelines">Information Quality</a></li>
              <li><a href="https://www.civilrights.dot.gov/civil-rights-awareness-enforcement/employment-related/affirmative-employment/no-fear-act">No FEAR Act</a></li>
              <li><a href="https://www.oig.dot.gov/">Office of Inspector General</a></li>
              <li><a href="https://www.fmcsa.dot.gov/mission/federal-motor-carrier-safety-administration-online-privacy-policy">Privacy Policy</a></li>
              <li><a href="https://www.transportation.gov/vulnerability-disclosure-policy">Vulnerability Disclosure Policy</a></li>
              <li><a href="https://www.usa.gov/">USA.gov</a></li>
              <li><a href="https://www.transportation.gov/web-policies">Web Policies and Notices</a></li>
              <li><a href="https://www.transportation.gov/web-standards">Web Standards</a></li>
            </ul>
          </section>
          {/* Four footer columns as before */}
          {/* ... */}
          <div className="footer-version text-muted small mt-4" style={{ textAlign: 'center' }}>
            Version: {version || 'Loading...'}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
